import {
  computed, observable, makeObservable,
} from 'mobx';
import { Axios } from '../utilities/network';
import { isWeb } from '../utilities/platform';
import RootStore from './root-store';
import { GetLocalStorage, SetLocalStorage } from '../utilities/cryptography';
import { ALLERGY_OPTIONS, ALLERGY_OPTIONS_CN, CURRENT_MEDICINE_TAKEN_OPTIONS, CURRENT_MEDICINE_TAKEN_OPTIONS_CN, MODALITY, PAST_DISEASE_OPTIONS, PAST_DISEASE_OPTIONS_CN, STREET_TYPE, SYMPTOM_OPTIONS, SYMPTOM_OPTIONS_CN, USER_INFO } from '../constants/storage-keys';
import { navigate } from 'gatsby';
import { CURRENT_PLATFORM } from '../constants/settings';
import { Gender, PAGE_SIZE } from '../constants/options';
import { ProfileTemplate } from '../utilities/profile';
import { GetApiLang, GetLangKey, GetUserProfile, Language } from '../utilities/general';
import { PackageFeatures } from '../utilities/package-subscription';


export default class OptionStore {
  loading: boolean = false;
  updating: boolean = false;
  searching: boolean = false;
  deleting: boolean = false;

  rootStore: RootStore;

  constructor(rootStore: RootStore) {
    makeObservable(this, {
      loading: observable,
      updating: observable,
      searching: observable,
      deleting: observable,
    });
    this.rootStore = rootStore;
  }

  searchSymptomsOptions = async (reqModel: any = {}, lang: Language = GetApiLang()) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Symptom/Search?lang=${lang}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      if (lang == Language.ENGLISH) SetLocalStorage(SYMPTOM_OPTIONS, res.data);
      else SetLocalStorage(SYMPTOM_OPTIONS_CN, res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchNewSymptomsOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Symptom/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      // if (lang == Language.ENGLISH) SetLocalStorage(SYMPTOM_OPTIONS, res.data);
      // else SetLocalStorage(SYMPTOM_OPTIONS_CN, res.data);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  // Predisposition 诱因
  searchSymptomPredispositionOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Symptom/Predisposition/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //Disease 既往史 /家族疾病
  searchDiagnosisDiseaseOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Disease/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //过敏药
  searchDiagnosisDrugOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Drug/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //过敏元
  searchDiagnosisTriggerOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Trigger/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //望诊
  searchDiagnosisInspectionOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Inspection/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //问诊
  searchDiagnosisInquiryOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Inquiry/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //脉搏
  searchDiagnosisPulseOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Pulse/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };
  //闻
  searchDiagnosisListeningAndSmellingOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/ListeningAndSmelling/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchDiagnosisTestOptions = async (skip: number, take: number, reqModel: any = {},) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Tests/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchAllergenOptions = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Allergen/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchPastDiseaseOptions = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/PastDisease/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchCurrentMedcineTakenOptions = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/MedicalTaken/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchDeterminationTcmOptions = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/DeterminationTcm/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchSyndromeOptions = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Syndrome/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchPrincipleOptions = async (skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/Principle/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };


  searchOptionsWithKey = async (key: string, skip: number, take: number, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/${key}/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  updateOptionWithKey = async (key: string, reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.put(`/api/Option/Diagnosis/${key}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  createOptionWithKey = async (key: string, reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/${key}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  deleteOptionWithKey = async (key: string, id: number) => {
    this.loading = true;
    try {
      const res = await Axios.delete(`/api/Option/Diagnosis/${key}/${id}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  deleteClinicOptions = async (reqModel: any[]) => {
    this.deleting = true;
    try {
      const res = await Axios.post(`/api/Option/Delete?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.deleting = false;
    }
  };

  searchTreatmentOption = async (skip: number, take: number = PAGE_SIZE, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Treatment/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, { ...reqModel, clinicId: GetUserProfile().currentClinicId });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  createTreatmentOption = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Treatment/?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  updateTreatmentOption = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.put(`/api/Option/Treatment/?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  deleteTreatmentOption = async (id: number) => {
    this.deleting = true;
    try {
      const res = await Axios.delete(`/api/Option/Treatment/${id}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.deleting = false;
    }
  };

  searchAddress = async (skip: number, take: number = PAGE_SIZE, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Address/Postcode/Search/${skip}/${take}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchAddressStreetType = async (skip: number = 0, take: number = 0, reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Address/StreetType/Search/${skip}/${take}?platformId=${CURRENT_PLATFORM}`, reqModel);
      const items = res.data.items;
      SetLocalStorage(STREET_TYPE, items.map((item: any) => ({ label: item.fullName, value: item.abbrName, id: item.id })));
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchPainType = async (reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/PainType/Search/0/0?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

    searchPainCondition = async (reqModel: any = {}) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Diagnosis/PainCondition/Search/0/0?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  createAcuPoint = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Acupuncture/AcuPoint?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  updateAcuPoint = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.put(`/api/Acupuncture/AcuPoint?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  deleteAcuPoint = async (pointId: number) => {
    this.loading = true;
    try {
      const res = await Axios.delete(`/api/Acupuncture/AcuPoint/${pointId}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  searchMassageMethod = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Option/Massage/Method/Search/0/0?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  createModality = async (reqModel: any) => {
    this.loading = true;
    try {
      const res = await Axios.post(`/api/Modality?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  };

  updateModality = async (reqModel: any) => {
    this.updating = true;
    try {
      const res = await Axios.put(`/api/Modality?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.updating = false;
    }
  };

  deleteModality = async (id: number) => {
    this.deleting = true;
    try {
      const res = await Axios.delete(`/api/Modality/${id}?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.deleting = false;
    }
  };

  searchModality = async (reqModel: any) => {
    this.searching = true;
    try {
      const res = await Axios.post(`/api/Modality/Search/0/0?lang=${GetApiLang()}&platformId=${CURRENT_PLATFORM}`, reqModel);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.searching = false;
    }
  };


}
